module.exports = __webpack_public_path__ + "static/media/c02-02-4.520dd923.png";